import {MeasurementStatisticContainer} from "../containers/MeasurementStatisticContainer";

export const MeasurementStatisticPage = () => (
    <MeasurementStatisticContainer/>
)